/**
 * - Dagny is the current font.
 * - Nitti Grotesk NN is a font that will replace Dagny. It is behind a feature flag at the moment.
 * - Calibri is used on Windows for Greek.
 * - Arial is used as fallback for Greek (e.g. Mac).
 */
export const FONT_FACE_DAGNY_DISPLAY = 'NNDagnyDisplayCompPro';
export const FONT_FACE_DAGNY_TEXT = 'NNDagnyTextComp';
export const FONT_FACE_NITTI_GROTESK_NN_HEADING = 'NittiGroteskNN-Heading';
export const FONT_FACE_NITTI_GROTESK_NN_TEXT_REGULAR = 'NittiGroteskNN-TextRegular';
export const FONT_FACE_NITTI_GROTESK_NN_TEXT_MEDIUM = 'NittiGroteskNN-TextMedium';
export const FONT_FACE_NITTI_GROTESK_NN_TEXT_BOLD = 'NittiGroteskNN-TextBold';
export const FONT_FACE_CALIBRI = 'Calibri';
export const FONT_FACE_ARIAL = 'Arial';
